import React, { useState, useRef } from 'react';

function Signature({ name, title, phone, email }) {
  const signatureRef = useRef(null);
  const [copySuccess, setCopySuccess] = useState('');
  const copyToClipboard = async (e) => {
    // const code = signatureRef.current.innerHTML;
    // console.log(code);
    // navigator.clipboard.writeText(code);
    // e.target.focus();

    const blob = new Blob([signatureRef.current.innerHTML], { type: 'text/html' });
    const clipboardItem = new ClipboardItem({ 'text/html': blob });

    try {
      await navigator.clipboard.write([clipboardItem]);
      setCopySuccess('Copied!');
      setTimeout(() => {
        setCopySuccess('');
      }, 3000);
    } catch (err) {
      setCopySuccess('Something went wrong');
    }
  };

  if (name === '') {
    name = 'XXXXX';
  }
  if (title === '') {
    title = 'XXXXX';
  }
  if (email === '') {
    email = 'XXXXX';
  }
  if (phone === '') {
    phone = 'XXXXX';
  }

  const baseURL = process.env.REACT_APP_BASEURL;

  const companyData = {
    website: 'goddessretreats.com',
    websiteUrl: 'https://goddessretreats.com',
    youtube: 'https://www.youtube.com/channel/UC9MzzNAC0jvWdb63u9DkuZQ',
    facebook: 'https://www.facebook.com/theoriginalgoddessretreats/',
    instagram: 'https://www.instagram.com/goddessretreats/',
    tiktok: 'https://www.tiktok.com/@goddessretreats',
    calendly: 'https://calendly.com/goddessretreatsbali/15min',
  };

  const assets = {
    logo: `${baseURL}/assets/logo.png`,
    phone: `${baseURL}/assets/phone.png`,
    email: `${baseURL}/assets/email.png`,
    website: `${baseURL}/assets/website.png`,
    ig: `${baseURL}/assets/ig.png`,
    tt: `${baseURL}/assets/tt.png`,
    fb: `${baseURL}/assets/fb.png`,
    yt: `${baseURL}/assets/yt.png`,
    button: `${baseURL}/assets/button.png`,
    badge: `${baseURL}/assets/badge.png`,
  };

  const generateWhatsappLink = (phoneNumber) => {
    const phoneNumberFormatted = phoneNumber.replace(/[ +-]/g, '');
    return `https://wa.me/${phoneNumberFormatted}`;
  };

  return (
    <div className="signature-container">
      <div ref={signatureRef}>
        <table style={{ direction: 'ltr', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: 0, height: 12, lineHeight: 0 }} />
            </tr>
            <tr>
              <td>
                <table cellPadding={0} cellSpacing={0} border={0} style={{ width: '100%', textAlign: 'left' }} width="100%">
                  <tbody>
                    <tr>
                      <td>
                        <table cellPadding={0} cellSpacing={0} style={{ borderCollapse: 'collapse', lineHeight: '1.15' }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: 'top', padding: '0.01px 12px 0.01px 1px', width: 65, textAlign: 'center' }}>
                                <a style={{ margin: 1, textDecoration: 'none!important' }} href={companyData.websiteUrl} rel="nofollow noreferrer" target="_blank">
                                  <img border={0} src={assets.logo} height={65} width={65} alt="Logo" style={{ width: 65, verticalAlign: 'middle', borderRadius: 0, height: 65, border: 0, display: 'block' }} />
                                </a>
                              </td>
                              <td valign="top" style={{ padding: '0.01px 0.01px 0.01px 12px', verticalAlign: 'top', borderLeft: 'dotted 2px #f6f0ea' }}>
                                <table cellPadding={0} cellSpacing={0} style={{ borderCollapse: 'collapse' }}>
                                  <tbody>
                                    <tr>
                                      <td style={{ padding: '0.01px' }}>
                                        <p style={{ margin: '0.1px', lineHeight: '108%', fontSize: 16 }}>
                                          <span style={{ fontFamily: 'Arial', fontSize: 16, fontWeight: 'bold', color: '#646464', letterSpacing: 0, whiteSpace: 'nowrap' }}>{name}</span>
                                          <br />
                                          <span style={{ fontFamily: 'Arial', fontSize: 13, fontWeight: 'bold', color: '#646464', whiteSpace: 'nowrap' }}>
                                            {title},<span>&nbsp;</span>
                                          </span>
                                          <span style={{ fontFamily: 'Arial', fontSize: 13, fontWeight: 'bold', color: '#646464', whiteSpace: 'nowrap' }}>Goddess Retreats</span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <table cellPadding={0} cellSpacing={0} style={{ borderCollapse: 'collapse' }}>
                                          <tbody>
                                            <tr>
                                              <td nowrap width={111} style={{ paddingTop: 12, whiteSpace: 'nowrap', width: 111, fontFamily: 'Arial' }}>
                                                <p style={{ margin: 1, lineHeight: '99%', fontSize: 11 }}>
                                                  <span style={{ whiteSpace: 'nowrap' }}>
                                                    <img src={assets.phone} style={{ lineHeight: '120%', width: 11, marginBottom: '-1px' }} width={11} height={11} alt="icon" />
                                                    &nbsp; &nbsp;
                                                    <a href={`${generateWhatsappLink(phone)}`} target="_blank" style={{ fontFamily: 'Arial', textDecoration: 'none' }} rel="nofollow noreferrer">
                                                      <span style={{ lineHeight: '120%', fontFamily: 'Arial', fontSize: 11, colorScheme: 'only', color: '#212121', whiteSpace: 'nowrap', textDecoration: 'none' }}>{phone}</span>
                                                    </a>
                                                  </span>
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td nowrap width={111} style={{ paddingTop: 6, whiteSpace: 'nowrap', width: 111, fontFamily: 'Arial' }}>
                                                <p style={{ margin: 1, lineHeight: '99%', fontSize: 11 }}>
                                                  <span style={{ whiteSpace: 'nowrap' }}>
                                                    <img src={assets.email} style={{ lineHeight: '120%', width: 11, marginBottom: '' }} width={11} height={11} alt="icon" />
                                                    &nbsp; &nbsp;
                                                    <a href={`mailto:${email}`} target="_blank" style={{ fontFamily: 'Arial', textDecoration: 'none' }} rel="nofollow noreferrer">
                                                      <span style={{ lineHeight: '120%', fontFamily: 'Arial', fontSize: 11, colorScheme: 'light', color: '#212121', textDecoration: 'none', whiteSpace: 'nowrap' }}>{email}</span>
                                                    </a>
                                                  </span>
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td nowrap width={142} style={{ paddingTop: 6, whiteSpace: 'nowrap', width: 142, fontFamily: 'Arial' }}>
                                                <p style={{ margin: 1, lineHeight: '99%', fontSize: 11 }}>
                                                  <span style={{ whiteSpace: 'nowrap' }}>
                                                    <img src={assets.website} style={{ lineHeight: '120%', width: 11, marginBottom: '-2px' }} width={11} height={11} alt="icon" />
                                                    &nbsp; &nbsp;
                                                    <a href={companyData.websiteUrl} target="_blank" style={{ fontFamily: 'Arial', textDecoration: 'none' }} rel="nofollow noreferrer">
                                                      <span style={{ lineHeight: '120%', fontFamily: 'Arial', fontSize: 11, colorScheme: 'light', color: '#212121', whiteSpace: 'nowrap' }}>{companyData.website}</span>
                                                    </a>
                                                  </span>
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ padding: '12px 0.01px 0.01px 0.01px' }}>
                                        <table border={0} cellPadding={0} cellSpacing={0}>
                                          <tbody>
                                            <tr>
                                              <td align="left" style={{ paddingRight: 6, textAlign: 'center', paddingTop: 0 }} s>
                                                <p style={{ margin: 1 }}>
                                                  <a href={companyData.instagram} target="_blank" rel="nofollow noreferrer" style={{ textDecoration: 'none' }}>
                                                    <img width={24} height={24} src={assets.ig} style={{ float: 'left', border: 'none' }} border={0} alt="instagram" />
                                                  </a>
                                                </p>
                                              </td>
                                              <td align="left" style={{ paddingRight: 6, textAlign: 'center', paddingTop: 0 }}>
                                                <p style={{ margin: 1 }}>
                                                  <a href={companyData.tiktok} target="_blank" rel="nofollow noreferrer" style={{ textDecoration: 'none' }}>
                                                    <img width={24} height={24} src={assets.tt} style={{ float: 'left', border: 'none' }} border={0} alt="tiktok" />
                                                  </a>
                                                </p>
                                              </td>
                                              <td align="left" style={{ paddingRight: 6, textAlign: 'center', paddingTop: 0 }}>
                                                <p style={{ margin: 1 }}>
                                                  <a href={companyData.facebook} target="_blank" rel="nofollow noreferrer" style={{ textDecoration: 'none' }}>
                                                    <img width={24} height={24} src={assets.fb} style={{ float: 'left', border: 'none' }} border={0} alt="facebook" />
                                                  </a>
                                                </p>
                                              </td>
                                              <td align="left" style={{ paddingRight: 6, textAlign: 'center', paddingTop: 0 }}>
                                                <p style={{ margin: 1 }}>
                                                  <a href={companyData.youtube} target="_blank" rel="nofollow noreferrer" style={{ textDecoration: 'none' }}>
                                                    <img width={24} height={24} src={assets.yt} style={{ float: 'left', border: 'none' }} border={0} alt="youtube" />
                                                  </a>
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ lineHeight: '1%', paddingTop: 16, fontSize: 1 }} />
                    </tr>
                    <tr>
                      <td>
                        <div style={{ fontSize: 12, color: '#333', lineHeight: 'normal' }}>
                          <table>
                            <tbody>
                              <tr>
                                <td style={{ textAlign: 'left', lineHeight: 1, width: 130, verticalAlign: 'top', color: '#212121' }}>
                                  <p style={{ fontFamily: 'Arial', fontSize: '11px', marginBottom: '10px', lineHeight: '110%' }}>
                                    <span style={{ fontFamily: 'Arial', fontSize: '11px', marginBottom: '10px', lineHeight: '110%' }}>Book a call with our team to get all the details you need.</span>
                                  </p>
                                  <a href={companyData.calendly} style={{ display: 'block', textDecoration: 'none', fontSize: 0 }} target="_blank" rel="noreferrer">
                                    <img alt="Custom Button App" height={40} width={169} src={assets.button} />
                                  </a>
                                </td>
                                <td style={{ paddingLeft: 25 }}>
                                  <p style={{ margin: 1 }}>
                                    <img alt="Awards banner" height={100} width={100} src={assets.badge} style={{ width: 100, height: 100 }} />
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ lineHeight: '1%', paddingTop: 16, fontSize: 1 }} />
                    </tr>
                    <tr>
                      <td>
                        <table cellPadding={0} cellSpacing={0} width="100%" style={{ width: '100%', color: 'gray', borderTop: '1px solid gray', lineHeight: 'normal' }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: '9px 8px 0 0' }}>
                                <p style={{ color: '#888888', textAlign: 'left', fontSize: 10, margin: 1, lineHeight: '120%', fontFamily: 'Arial' }}>IMPORTANT: The contents of this email and any attachments are confidential. They are intended for the named recipient(s) only. If you have received this email by mistake, please notify the sender immediately and do not disclose the contents to anyone or make copies thereof.</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ lineHeight: '1%', paddingTop: 16, fontSize: 1 }} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ fontFamily: '"ws-id BdAB2Dy7QDOl"', fontSize: '0.01px', lineHeight: 0 }}>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        {document.queryCommandSupported('copy') && (
          <div>
            <button onClick={copyToClipboard} className="styled-button">
              Copy signature
            </button>
            <div style={{ marginTop: '10px' }}>{copySuccess}</div>
          </div>
        )}
      </div>
    </div>
  );
}
export default Signature;
